import React from 'react';
import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';
import SessionDetails from 'components/InPersonTraining/shared/SessionDetails';
import CalendarGraphic from 'components/InPersonTraining/shared/CalendarGraphic';

const EventCard = ({ event, setSelectedEvent, previewing }) => {
  /*
  Fix snake_case issues. Once all of InPersonTraining/Training
  sends camelCase including in child components, then we can remove this.
  */
  event.numberOfSessions = event.numberOfSessions
    ? event.numberOfSessions
    : event.number_of_sessions;
  event.nextSession = event.nextSession
    ? event.nextSession
    : event.next_session;
  event.rsvpType = event.rsvpType ? event.rsvpType : event.rsvp_type;

  const hasMultipleSessions = event.numberOfSessions > 1;
  const moreSessionsCount = hasMultipleSessions
    ? event.numberOfSessions - 1
    : null;

  const handleCardSelection = () => {
    setSelectedEvent(event);
  };

  return (
    <div
      role="button"
      className="EventItem--card d-f"
      onClick={handleCardSelection}
      onKeyDown={e => {
        if (e.keycode === 13 || e.code === 'Enter') {
          handleCardSelection();
        }
      }}
      tabIndex={0}
    >
      <CalendarGraphic isLocalTime session={event.nextSession} />
      <div className="EventItem--info p-16">
        <Text variant={TEXT_VARIANTS.BODY_BOLD} className="mb-8 d-ib">
          {event.name}
        </Text>
        <SessionDetails
          session={event.nextSession}
          eventId={event.id}
          showRegistrationCap
          hasMultipleSessions={hasMultipleSessions}
          moreSessionsCount={moreSessionsCount}
          previewing={previewing}
          rsvpType={
            (event.rsvpType === 0 || event.rsvpType === 'all') &&
            hasMultipleSessions
              ? 'all'
              : 'single'
          }
          sessionCount={event.numberOfSessions}
        />
      </div>
    </div>
  );
};

export default EventCard;
